import {TalkViewerTypeVo} from '../../common/shared/api/gateway/enums/TalkViewerTypeVo.enum';
import {TalkDownloadDataVo} from '../../common/shared/api/gateway/viewer/TalkDownloadDataVo.interface';
import {TalkDownloadData, TalkViewerType} from '../generated/types';

export function createTalkDownloadData({
  dec,
  host,
  path,
  talk_viewer_type,
}: TalkDownloadDataVo): TalkDownloadData {
  return {
    dec,
    host,
    path,
    talkViewerType: talk_viewer_type && map[talk_viewer_type],
  };
}

const map: {[key in TalkViewerTypeVo]: TalkViewerType} = {
  [TalkViewerTypeVo.Tap]: TalkViewerType.Tap,
  [TalkViewerTypeVo.TapScroll]: TalkViewerType.TapScroll,
};
